import { FilterFieldGroup } from '@App/forms/common/filter-field-group'
import { FormFieldTypes } from '@App/enum/form-field-types'
import StatusComponent from '@Components/Status'
import { SUGGESTION_STATUS_VALUES } from '@Components/MatchComponents/v2/suggestion-status'
import React from 'react'
import { DeepPartial, ExtractObjects } from 'react-hook-form'
import FilterSection from '@Components/Search/SearchWithCriteria/FilterSection'
import { SubmissionFilterInputs } from '@Components/MatchComponents/v2/SubmissionFilterSection'

interface SubmissionFilterProps {
    // Match the FilterSection signature which provides a DeepPartial of the filter
    // (or undefined during intermediate updates).
    handleFilterValueChange?: (
        filter:
            | (ExtractObjects<SubmissionFilterInputs> extends never
                  ? SubmissionFilterInputs
                  : DeepPartial<SubmissionFilterInputs>)
            | undefined
    ) => void
    onApplyFilter?: (value: boolean) => void
    onResetFilter?: () => void
}
const SubmissionFilters = (props: SubmissionFilterProps) => {
    const submissionFilters: Array<FilterFieldGroup<SubmissionFilterInputs>> = [
        {
            name: 'Submission Status Filter',
            allowMultiple: false,
            filterFields: [
                {
                    SUBMITTED: {
                        type: FormFieldTypes.CHECKBOX,
                        checked: false,
                        name: 'SUBMITTED',
                        label: '',
                        children: <StatusComponent withCount={false} status={SUGGESTION_STATUS_VALUES.SUBMITTED} big />,
                        rounded: true,
                    },
                },
                {
                    ACCEPTED: {
                        type: FormFieldTypes.CHECKBOX,
                        checked: false,
                        name: 'ACCEPTED',
                        label: '',
                        children: <StatusComponent withCount={false} status={SUGGESTION_STATUS_VALUES.ACCEPTED} big />,
                        rounded: true,
                    },
                },
                {
                    PARTIALLY_ACCEPTED: {
                        type: FormFieldTypes.CHECKBOX,
                        checked: false,
                        name: 'PARTIALLY_ACCEPTED',
                        label: '',
                        children: (
                            <StatusComponent
                                withCount={false}
                                status={SUGGESTION_STATUS_VALUES.PARTIALLY_ACCEPTED}
                                big
                            />
                        ),
                        rounded: true,
                    },
                },
                {
                    REJECTED: {
                        type: FormFieldTypes.CHECKBOX,
                        checked: false,
                        name: 'REJECTED',
                        label: '',
                        children: <StatusComponent withCount={false} status={SUGGESTION_STATUS_VALUES.REJECTED} big />,
                        rounded: true,
                    },
                },
                {
                    IN_PROGRESS: {
                        type: FormFieldTypes.CHECKBOX,
                        checked: false,
                        name: 'IN_PROGRESS',
                        label: '',
                        children: (
                            <StatusComponent withCount={false} status={SUGGESTION_STATUS_VALUES.IN_PROGRESS} big />
                        ),
                        rounded: true,
                    },
                },
                {
                    SUPERSEDED: {
                        type: FormFieldTypes.CHECKBOX,
                        checked: false,
                        name: 'SUPERSEDED',
                        label: '',
                        children: (
                            <StatusComponent withCount={false} status={SUGGESTION_STATUS_VALUES.SUPERSEDED} big />
                        ),
                        rounded: true,
                    },
                },
            ],
        },
    ]
    return <FilterSection {...props} filterCollections={submissionFilters} />
}
export default SubmissionFilters
